/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseResponseBoolean,
  BaseResponsePageResponseDocumentDto,
  BaseResponsePageResponseDocumentMyDeskResponse,
  BaseResponsePageResponseNoticeDto,
  BaseResponseStatusCountResponse,
  BaseResponseUserResponse,
  GetDocumentStatusCountParams,
  GetLatestAnalysisParams,
  GetLatestArchivesParams,
  GetLatestNoticesParams,
  GetLatestWorkParams,
  GetUserInfoParams,
  NotifyMyDeskParams,
} from './data-contracts';
import {HttpClient, RequestParams} from './http-client';

export class Dashboard<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description WORK 문서 리스트
   *
   * @tags Dashboard
   * @name GetLatestWork
   * @summary WORK 문서 노출
   * @request GET:/app/dashboards/work/latest
   * @secure
   * @response `200` `BaseResponsePageResponseDocumentMyDeskResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getLatestWorkKey = (query: GetLatestWorkParams) => ['app', 'dashboards', 'work', 'latest', query];

  getLatestWork = async (query: GetLatestWorkParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseDocumentMyDeskResponse, void>({
      path: `/app/dashboards/work/latest`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 메인 회원 정보 노출
   *
   * @tags Dashboard
   * @name GetUserInfo
   * @summary 회원 정보 및 회원 권한 판별
   * @request GET:/app/dashboards/users/info
   * @secure
   * @response `200` `BaseResponseUserResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUserInfoKey = (query: GetUserInfoParams) => ['app', 'dashboards', 'users', 'info', query];

  getUserInfo = async (query: GetUserInfoParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUserResponse, void>({
      path: `/app/dashboards/users/info`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 유보, 결정, 기각, 임시저장 상태별 문서 count
   *
   * @tags Dashboard
   * @name GetDocumentStatusCount
   * @summary 마이 데스크 문서 상태별 count
   * @request GET:/app/dashboards/status-count
   * @secure
   * @response `200` `BaseResponseStatusCountResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentStatusCountKey = (query: GetDocumentStatusCountParams) => ['app', 'dashboards', 'status-count', query];

  getDocumentStatusCount = async (query: GetDocumentStatusCountParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseStatusCountResponse, void>({
      path: `/app/dashboards/status-count`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description My Desk의 최신 변경 사항을 알림
   *
   * @tags Dashboard
   * @name NotifyMyDesk
   * @summary MyDesk 변경 있음 표시
   * @request GET:/app/dashboards/notification
   * @secure
   * @response `200` `BaseResponseBoolean` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  notifyMyDeskKey = (query: NotifyMyDeskParams) => ['app', 'dashboards', 'notification', query];

  notifyMyDesk = async (query: NotifyMyDeskParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseBoolean, void>({
      path: `/app/dashboards/notification`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 메인 대시보드 공지사항 리스트
   *
   * @tags Dashboard
   * @name GetLatestNotices
   * @summary 공지사항 노출
   * @request GET:/app/dashboards/notices/latest
   * @secure
   * @response `200` `BaseResponsePageResponseNoticeDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getLatestNoticesKey = (query: GetLatestNoticesParams) => ['app', 'dashboards', 'notices', 'latest', query];

  getLatestNotices = async (query: GetLatestNoticesParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseNoticeDto, void>({
      path: `/app/dashboards/notices/latest`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description ARCHIVE 문서 리스트
   *
   * @tags Dashboard
   * @name GetLatestArchives
   * @summary ARCHIVE 문서 노출
   * @request GET:/app/dashboards/archives/latest
   * @secure
   * @response `200` `BaseResponsePageResponseDocumentDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getLatestArchivesKey = (query: GetLatestArchivesParams) => ['app', 'dashboards', 'archives', 'latest', query];

  getLatestArchives = async (query: GetLatestArchivesParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseDocumentDto, void>({
      path: `/app/dashboards/archives/latest`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description ANALYSIS 문서 리스트
   *
   * @tags Dashboard
   * @name GetLatestAnalysis
   * @summary ANALYSIS 문서 노출
   * @request GET:/app/dashboards/analysis/latest
   * @secure
   * @response `200` `BaseResponsePageResponseDocumentMyDeskResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getLatestAnalysisKey = (query: GetLatestAnalysisParams) => ['app', 'dashboards', 'analysis', 'latest', query];

  getLatestAnalysis = async (query: GetLatestAnalysisParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseDocumentMyDeskResponse, void>({
      path: `/app/dashboards/analysis/latest`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
